import { Route, Switch, useRouteMatch } from "react-router";

import ImportList from "./ImportList";

// API keys and Documentation moved to the Developer section (developer/, S7b), and Integrations too (DSEC INT):
// App.js redirects /import/api-keys, /import/docs and /import/integrations there.

const XmlPage = (props: any) => {
  let { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/run/:tab/:id`}>
        <ImportList {...props} />
      </Route>
      <Route path={`${path}/run/:tab`}>
        <ImportList {...props}/>
      </Route>
      <Route exact path={`${path}`}>
        <ImportList {...props} />
      </Route>
    </Switch>
  );
};

export default XmlPage;
